module.exports = __webpack_public_path__ + "static/media/front.45c1952d.jpg";